var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIronSvgrepocom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.75 6H10.5V7.5H18.75C19.164 7.5 19.5 7.83675 19.5 8.25V9H11.7465C9.11175 9 6.6705 10.3822 5.31525 12.6412L3 16.5V18H21V8.25C21 7.0095 19.9905 6 18.75 6ZM19.5 16.5H4.749L6.6015 13.413C7.67925 11.616 9.651 10.5 11.7465 10.5H19.5V16.5ZM15 15H13.5V13.5H15V15ZM18 15H16.5V13.5H18V15Z",
    fill: "#9393B0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIronSvgrepocom);
export default __webpack_public_path__ + "static/media/iron_svgrepo.com.cd6c3d36b87434eae682c99cf6bb475a.svg";
export { ForwardRef as ReactComponent };